export default [
  { name: "", value: "*:*" },

  {
    name: "Full Access",
    value: "analytics:*",
    description: "Grants complete access to all analytics features.",
  },
  {
    name: "View Brokerage Analytics",
    value: "analytics:view_brokerage",
    description: "Allows viewing brokerage analytics data.",
  },
  {
    name: "View Premium Analytics",
    value: "analytics:view_premium",
    description: "Allows viewing premium analytics data.",
  },
  {
    name: "View Fac. Premium Analytics",
    value: "analytics:view_fac_premium",
    description: "Allows viewing facultative premium analytics data.",
  },
  {
    name: "View Sum. Insured Analytics",
    value: "analytics:view_sum_insured",
    description: "Allows viewing sum insured analytics data.",
  },
  {
    name: "View Fac. Sum Insured Analytics",
    value: "analytics:view_fac_sum_insured",
    description: "Allows viewing facultative sum insured analytics data.",
  },

  {
    name: "Full Access",
    value: "offers:*",
    description: "Grants complete access to all offers features.",
  },
  {
    name: "Manage Offers",
    value: "offers:manage",
    description: "Allows overseeing and managing all offers.",
  },
  {
    name: "View Offers",
    value: "offers:view",
    description: "Allows viewing existing offers.",
  },
  {
    name: "Create Offers",
    value: "offers:create",
    description: "Allows creating new offers for customers.",
  },
  {
    name: "Approve Offers",
    value: "offers:approve",
    description: "Allows approving offers.",
  },
  {
    name: "Reject Offers",
    value: "offers:reject",
    description: "Allows rejecting offers.",
  },
  {
    name: "Update Offers",
    value: "offers:update",
    description: "Allows editing existing offers.",
  },
  {
    name: "Reinstate Offers",
    value: "offers:reinstate",
    description: "Allows reinstatement of offers.",
  },
  {
    name: "Payment on Offers",
    value: "offers:payment",
    description: "Allows managing payment on offers.",
  },
  {
    name: "Delete Offers",
    value: "offers:delete",
    description: "Allows deleting offers from the system.",
  },
  {
    name: "Attach Documents to Offers",
    value: "offers:attach_docs",
    description: "Allows attaching documents to offers.",
  },
  {
    name: "Reopen Offers",
    value: "offers:reopen",
    description: "Allows reopening offers.",
  },

  {
    name: "Full Access",
    value: "endorsements:*",
    description: "Grants complete access to all endorsement features.",
  },
  {
    name: "Manage Endorsements",
    value: "endorsements:manage",
    description: "Allows managing endorsement records.",
  },
  {
    name: "View Endorsements",
    value: "endorsements:view",
    description: "Allows viewing existing endorsements.",
  },
  {
    name: "Create Endorsements",
    value: "endorsements:create",
    description: "Allows creating new endorsements.",
  },
  {
    name: "Update Endorsements",
    value: "endorsements:update",
    description: "Allows updating existing endorsements.",
  },
  {
    name: "Delete Endorsements",
    value: "endorsements:delete",
    description: "Allows deleting endorsements from the system.",
  },
  {
    name: "Approve Endorsements",
    value: "endorsements:approve",
    description: "Allows approving endorsements.",
  },
  {
    name: "Full Access",
    value: "claims:*",
    description: "Grants complete access to all claims features.",
  },
  {
    name: "Manage Claims",
    value: "claims:manage",
    description: "Allows managing claims records.",
  },
  {
    name: "View Claims",
    value: "claims:view",
    description: "Allows viewing existing claims.",
  },
  {
    name: "Create Claims",
    value: "claims:create",
    description: "Allows creating new claims.",
  },
  {
    name: "Update Claims",
    value: "claims:update",
    description: "Allows updating existing claims.",
  },
  {
    name: "Delete Claims",
    value: "claims:delete",
    description: "Allows deleting claims from the system.",
  },
  {
    name: "Full Access",
    value: "treaty_claims:*",
    description: "Grants complete access to all treaty claims features.",
  },
  {
    name: "Manage Claims",
    value: "treaty_claims:manage",
    description: "Allows managing treaty claims records.",
  },
  {
    name: "View Claims",
    value: "treaty_claims:view",
    description: "Allows viewing existing treaty claims.",
  },
  {
    name: "Create Claims",
    value: "treaty_claims:create",
    description: "Allows creating new treaty claims.",
  },
  {
    name: "Update Claims",
    value: "treaty_claims:update",
    description: "Allows updating existing treaty claims.",
  },
  {
    name: "Delete Claims",
    value: "treaty_claims:delete",
    description: "Allows deleting treaty claims from the system.",
  },

  {
    name: "Full Access",
    value: "treaties:*",
    description: "Grants complete access to all treaty features.",
  },
  {
    name: "Manage Treaties",
    value: "treaties:manage",
    description: "Allows managing treaty agreements and terms.",
  },
  {
    name: "Create Treaties",
    value: "treaties:create",
    description: "Allows creating new treaty records.",
  },
  {
    name: "Update Treaties",
    value: "treaties:update",
    description: "Allows editing and updating treaty details.",
  },
  {
    name: "Import Treaties",
    value: "treaties:import",
    description: "Allows bulk import of treaties from files or systems.",
  },
  {
    name: "Delete Treaties",
    value: "treaties:delete",
    description: "Allows deleting treaties.",
  },
  {
    name: "Send Treaties",
    value: "treaties:send",
    description: "Allows sending treaties.",
  },
  {
    name: "Treaties Payments",
    value: "treaties:payments",
    description: "Allows managing treaty payments.",
  },
  {
    name: "Approve Treaties",
    value: "treaties:approve",
    description: "Allows approving treaties.",
  },
  {
    name: "Full Access",
    value: "insurers:*",
    description: "Grants complete access to all insurer features.",
  },
  {
    name: "Manage Insurers",
    value: "insurers:manage",
    description: "Allows managing insurer records.",
  },
  {
    name: "Create Insurers",
    value: "insurers:create",
    description: "Allows creating new insurer records.",
  },
  {
    name: "Update Insurers",
    value: "insurers:update",
    description: "Allows editing and updating insurer details.",
  },
  {
    name: "Assign Insurers",
    value: "insurers:assign",
    description: "Allows assigning insurers to specific cases or clients.",
  },
  {
    name: "Delete Insurers",
    value: "insurers:delete",
    description: "Allows deleting insurers.",
  },
  {
    name: "Full Access",
    value: "reinsurers:*",
    description: "Grants complete access to all reinsurer features.",
  },
  {
    name: "Manage Reinsurers",
    value: "reinsurers:manage",
    description: "Allows managing reinsurer records.",
  },
  {
    name: "Create Reinsurers",
    value: "reinsurers:create",
    description: "Allows creating new reinsurer records.",
  },
  {
    name: "Update Reinsurers",
    value: "reinsurers:update",
    description: "Allows editing and updating reinsurer details.",
  },
  {
    name: "Delete Reinsurers",
    value: "reinsurers:delete",
    description: "Allows deleting reinsurers.",
  },
  {
    name: "Assign Reinsurers",
    value: "reinsurers:assign",
    description: "Allows assigning reinsurers to specific cases or clients.",
  },
  {
    name: "Full Access",
    value: "reinsurance_brokers:*",
    description: "Grants complete access to all reinsurance broker features.",
  },
  {
    name: "Manage Reinsurance Brokers",
    value: "reinsurance_brokers:manage",
    description: "Allows managing reinsurance broker records.",
  },
  {
    name: "Create Reinsurance Brokers",
    value: "reinsurance_brokers:create",
    description: "Allows creating new reinsurance broker records.",
  },
  {
    name: "Update Reinsurance Brokers",
    value: "reinsurance_brokers:update",
    description: "Allows editing and updating reinsurance broker details.",
  },
  {
    name: "Assign Reinsurance Brokers",
    value: "reinsurance_brokers:assign",
    description:
      "Allows assigning reinsurance brokers to specific cases or clients.",
  },
  {
    name: "Delete Reinsurance Brokers",
    value: "reinsurance_brokers:delete",
    description: "Allows deleting reinsurance brokers.",
  },
  {
    name: "Full Access",
    value: "business:*",
    description: "Grants complete access to all business features.",
  },
  {
    name: "Manage Business",
    value: "business:manage",
    description: "Allows managing business entities and settings.",
  },
  {
    name: "Create Business",
    value: "business:create",
    description: "Allows adding new businesses into the system.",
  },
  {
    name: "Update Business",
    value: "business:update",
    description: "Allows editing business records.",
  },
  {
    name: "Delete Business",
    value: "business:delete",
    description: "Allows deleting business records.",
  },
  {
    name: "Full Access",
    value: "treaty_program:*",
    description: "Grants complete access to all treaty programme features.",
  },
  {
    name: "Manage Treaty Programmes",
    value: "treaty_program:manage",
    description: "Allows managing treaty programme configurations.",
  },
  {
    name: "Create Treaty Programmes",
    value: "treaty_program:create",
    description: "Allows creating new treaty programmes.",
  },
  {
    name: "Update Treaty Programmes",
    value: "treaty_program:update",
    description: "Allows editing existing treaty programmes.",
  },
  {
    name: "Import Treaty Programmes",
    value: "treaty_program:import",
    description: "Allows bulk importing treaty programmes.",
  },
  {
    name: "Delete Treaty Programmes",
    value: "treaty_program:delete",
    description: "Allows deleting treaty programmes.",
  },
  {
    name: "Full Access",
    value: "reports:*",
    description: "Grants complete access to all report features.",
  },
  {
    name: "Manage Reports",
    value: "reports:manage",
    description: "Allows managing all reports and their settings.",
  },
  {
    name: "Create Reports",
    value: "reports:create",
    description: "Allows creating new reports.",
  },
  {
    name: "Update Reports",
    value: "reports:update",
    description: "Allows editing and updating reports.",
  },
  {
    name: "Import Reports",
    value: "reports:import",
    description: "Allows importing report data in bulk.",
  },
  {
    name: "Delete Reports",
    value: "reports:delete",
    description: "Allows deleting reports from the system.",
  },
  {
    name: "Full Access",
    value: "employees:*",
    description: "Grants complete access to all employee features.",
  },
  {
    name: "Manage Employees",
    value: "employees:manage",
    description: "Allows managing employee records.",
  },
  {
    name: "Add Employees",
    value: "employees:create",
    description: "Allows adding new employees to the system.",
  },
  {
    name: "Update Employees",
    value: "employees:update",
    description: "Allows editing employee information.",
  },
  {
    name: "Reset Employees",
    value: "employees:reset",
    description: "Allows resetting employee data to default values.",
  },
  {
    name: "Delete Employees",
    value: "employees:delete",
    description: "Allows deleting employee records.",
  },
  {
    name: "Assign Cedant",
    value: "employees:assign",
    description: "Allows assigning cedants to employees.",
  },

  {
    name: "Full Access",
    value: "place-it:*",
    description: "Grants complete access to all Place IT features.",
  },
  {
    name: "Manage Place IT",
    value: "place-it:manage",
    description: "Allows managing Place IT records.",
  },
  {
    name: "Approve Underwriters",
    value: "place-it:approve_underwriters",
    description: "Allows approving underwriters in Place IT.",
  },
  {
    name: "Send Offer Documents",
    value: "offers:send",
    description: "Allows sending existing offer documents.",
  },
  {
    name: "Approve Offers",
    value: "place-it:approve_offers",
    description: "Allows approving offers in Place IT.",
  },
  {
    name: "Manage Campaigns",
    value: "place-it:manage_campaigns",
    description: "Allows managing campaigns in Place IT.",
  },
  {
    name: "Manage Targets Configuration",
    value: "place-it:manage_targets_configuration",
    description: "Allows managing targets configuration in Place IT.",
  },
  {
    name: "Manage Targets Badges",
    value: "place-it:manage_targets_badges",
    description: "Allows managing targets badges in Place IT.",
  },
  {
    name: "Manage Points Redemptions",
    value: "place-it:manage_points_redemptions",
    description: "Allows managing points redemptions in Place IT.",
  },

  {
    name: "Full Access",
    value: "auto_fac:*",
    description: "Grants complete access to all auto fac features.",
  },
  {
    name: "Manage Auto Fac Configurations",
    value: "auto_fac:manage",
    description: "Allows managing auto fac configurations.",
  },
  {
    name: "View Auto Fac Configurations",
    value: "auto_fac:view",
    description: "Allows viewing existing auto fac configurations.",
  },
  {
    name: "Create Auto Fac Configurations",
    value: "auto_fac:create",
    description: "Allows creating new auto fac configurations.",
  },
  {
    name: "Update Auto Fac Configurations",
    value: "auto_fac:update",
    description: "Allows updating existing auto fac configurations.",
  },
  {
    name: "Delete Auto Fac Configurations",
    value: "auto_fac:delete",
    description: "Allows deleting auto fac configurations.",
  },
] as const;
